import * as Yup from "yup";
export const validationSchema = Yup.object().shape({
  name: Yup.string().required("First Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  number: Yup.string()
    .required("Number is required")
    .matches(/^\d{12}$/, "Number must be exactly 12 digits"),
  message: Yup.string().required("Message is required"),
  lastName: Yup.string().required("Last Name is required"),
});
